import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  changeAreaLinkState,
  setTraineeAreaViewState,
  updateArea,
  updateKnowledgeAreaStatus,
  updateKnowledgeElement,
  updateTraineeRoleArea,
} from '../../slices/traineeSlice';
import { requestTraineeRoleData } from '../../slices/traineeSlice';
import LoadScreen from '../../components/LoadScreen';
import Role from '../../components/Role';
import ErrorBoundary from '../../components/ErrorBoundary';
import { getWildcardPersonsService } from '../../services/personsService';
import { withSpan } from '../../utils/withSpan';

const mapStateToProps = (state) => ({
  role: state.trainee.selectedRole,
  persons: state.persons,
  wildcardPersons: state.trainee.wildcardPersons,
  loggedInUserId: state.user.employeeId,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      updateKnowledgeAreaStatus,
      changeAreaLinkState,
      setTraineeAreaViewState,
      updateTraineeRoleArea,
      updateKnowledgeElement,
      requestTraineeRoleData,
      updateArea,
    },
    dispatch
  ),
});

class TraineeRole extends Component {
  state = {
    isLoading: true,
    hasError: false,
    wildcardPersons: {},
  };

  componentDidMount() {
    getWildcardPersonsService()
      .then(({ data }) => {
        this.setState({ wildcardPersons: data });
      })
      .then(this.getRole)
      .catch(() => {
        this.setState({
          isLoading: false,
          hasError: true,
        });
      });
  }

  getRole = () => {
    const { match, requestTraineeRoleData } = this.props;
    return withSpan(
      {
        name: 'Open Role',
        op: 'data.fetch',
        attributes: {
          roleId: match.params.id,
          url: window.location.href,
        },
      },
      () =>
        requestTraineeRoleData(match.params.id)
          .then(() => {
            this.setState({
              isLoading: false,
            });
          })
          .catch((err) => {
            throw err;
          })
    );
  };

  onCloseHistoryModal = () => {
    const { role, requestTraineeRoleData } = this.props;
    requestTraineeRoleData(role.id, false);
  };

  onUpdateElement = ({ elementId, areaId }) => {
    const { loggedInUserId, updateKnowledgeElement, updateArea, role } =
      this.props;
    return updateKnowledgeElement({ personId: loggedInUserId, elementId }).then(
      (result) => {
        updateArea({ personId: loggedInUserId, areaId, roleId: role.id });
      }
    );
  };

  handleViewArea = (roleId, areaId) => {
    if (!roleId || !areaId) {
      console.error('Role ID or Area ID is missing');
      return;
    }
    return this.props.setTraineeAreaViewState({ roleId, areaId });
  };

  render() {
    const { isLoading, hasError, wildcardPersons } = this.state;
    const {
      changeAreaLinkState,
      loggedInUserId,
      role,
      setTraineeAreaViewState,
      updateTraineeRoleArea,
      updateKnowledgeAreaStatus,
      persons,
    } = this.props;
    if (isLoading) return <LoadScreen />;
    if (hasError) return <ErrorState fullHeight />;

    return (
      <ErrorBoundary>
        <Role
          additionalKnowledgeAreasSortOrder={
            role.additionalKnowledgeAreasSortOrder
          }
          categories={role.categories}
          completionPercentage={role.completionPercentage}
          description={role.description}
          id={role.id}
          knowledgeAreas={role.knowledgeAreas}
          knowledgeAreasSortOrder={role.knowledgeAreasSortOrder}
          knowledgeElements={role.knowledgeElements}
          loggedInUserId={loggedInUserId}
          menteeId={loggedInUserId}
          mentor={role.mentor}
          startDate={role.startDate}
          endDate={role.endDate}
          mentorId={role.mentorId}
          name={role.name}
          onChangeAreaLinkState={changeAreaLinkState}
          onViewArea={this.handleViewArea}
          persons={persons}
          updateKnowledgeAreaStatus={updateKnowledgeAreaStatus}
          updateKnowledgeArea={updateTraineeRoleArea}
          updateKnowledgeElement={this.onUpdateElement}
          wildcardPersons={wildcardPersons}
          onCloseHistoryModal={this.onCloseHistoryModal}
        />
      </ErrorBoundary>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TraineeRole);
